import { Badge, Heading, Text } from "@/design-system";
import type { LegalChange } from "../content/types";
import { formatLegalDate } from "../utils";

type LegalChangelogProps = {
  changelog: LegalChange[];
};

/**
 * Histórico de versões. Mudança em documento jurídico sem rastro é o que mais
 * corrói confiança: aqui fica o que mudou, quando, e em que versão.
 */
export const LegalChangelog = ({ changelog }: LegalChangelogProps) => (
  <section aria-labelledby="historico-title" className="flex flex-col gap-6">
    <Heading level={2} size={3} id="historico-title">
      Histórico de alterações
    </Heading>
    <ol className="border-ds-border flex flex-col gap-6 border-l pl-6">
      {changelog.map(entry => (
        <li key={entry.version} className="flex flex-col gap-2">
          <div className="flex flex-wrap items-center gap-3">
            <Badge tone="neutral">Versão {entry.version}</Badge>
            <Text as="span" size="small" tone="subtle">
              <time dateTime={entry.date}>{formatLegalDate(entry.date)}</time>
            </Text>
          </div>
          <ul className="marker:text-ds-ink-400 flex list-disc flex-col gap-1 pl-5">
            {entry.changes.map(change => (
              <Text as="li" key={change} size="small" tone="muted">
                {change}
              </Text>
            ))}
          </ul>
        </li>
      ))}
    </ol>
  </section>
);
